import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ReservationsHttpService} from '../../../../../services/http-services/reservations/reservations-http.service';
import {DatePickerModule} from '../../../../../shared-components/date-picker/date-picker.module';
import {DropdownModule} from '../../../../../shared-components/dropdowns/dropdown/dropdown.module';
import {DatePipe, NgForOf} from '@angular/common';
import {DropdownReactiveFormModule} from '../../../../../shared-components/dropdowns/dropdown-reactive-form/dropdown-reactive-form.module';
import {FormControlModule} from '../../../../../pipes/form-control/form-control.module';
import {PresentsHttpService} from '../../../../../services/http-services/presents/presents-http.service';
import {NotificationsModelTypeAdmin} from "../../../../../enums/notification-enums";
import {Subscription} from "rxjs";
import {WebsocketsHelperService} from "../../../../../services/helpers/websockets-helper.service";
import {NotificationsHelperService} from "../../../../../services/helpers/notifications-helper.service";

@Component({
  selector: 'gr-bought-gifts-tab',
  standalone: true,
  imports: [
    DatePickerModule,
    DropdownModule,
    NgForOf,
    DatePipe,
    FormControlModule
  ],
  templateUrl: './bought-gifts-tab.component.html'
})
export class BoughtGiftsTabComponent implements OnInit {
  gifts: any = [];
  stores: any = [];
  urlParams: {date: string | null, supplier: number | null} = {date: null, supplier: null};
  currentDate: Date = new Date();
  minDate = new Date(this.currentDate.getFullYear() - 10, this.currentDate.getMonth(), this.currentDate.getDate());
  unreadGiftsNotificationsCountSubscripton = new Subscription();
  @Input() giftsUnreadCount = 0;
  @Output() giftsNotificationsCount: EventEmitter<number> = new EventEmitter<number>();
  wsNotificationsSubscription= new Subscription();

  constructor(
    private reservationsHttpService: ReservationsHttpService,
    private presentsHttpService: PresentsHttpService,
    private datePipe: DatePipe,
    private notificationsHelperService: NotificationsHelperService,
    private websocketsHelperService: WebsocketsHelperService
  ) {
  }

  ngOnInit(): void {
    this.urlParams.date = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.getGifts();
    this.getToyStores();
    this.getNotificationsGiftsCount();

  }

  getToyStores(): void {
    this.presentsHttpService.getToyStores().then(res => {
      this.stores = res.data;
    });
  }

  getGifts(): void {
    this.reservationsHttpService.getReservationsGifts(this.urlParams).then(res => {
      this.gifts = res.data;
    });
  }

  getNotificationsGiftsCount(): void {
    this.reservationsHttpService.getNotificaitonsUnreadCOuntGifts().then(res => {
      console.log('getNotificationsGiftsCount', res)
      this.giftsUnreadCount = res.unread_count;
      this.giftsNotificationsCount.emit(this.giftsUnreadCount);
    });
  }

  exportBoughtGiftsPdf(): void {
    this.reservationsHttpService.getExportBoughtGiftsPdf(this.urlParams).subscribe((response: Blob) => {
      if (response.type === 'application/pdf') {
        const blobUrl = URL.createObjectURL(response);
        window.open(blobUrl, '_blank');
      } else {
        console.error('The fetched file is not a PDF');
      }
    });
  }

  exportBoughtGiftsExcel(): void {
    this.reservationsHttpService.getExportBoughtGiftsExcel(this.urlParams).subscribe((response: Blob) => {
      if (response.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        const blobUrl = URL.createObjectURL(response);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = 'Kupljeni_pokloni.xlsx';
        link.click();
        URL.revokeObjectURL(blobUrl);
      } else {
        console.error('The fetched file is not an Excel file');
      }
    });
  }

  onSelectedDate(selectedDate: any): void {
    this.urlParams.date = this.datePipe.transform(selectedDate, 'yyyy-MM-dd');
    this.getGifts();
  }

  onSelectedSupplier(supplier: any): void {
    this.urlParams.supplier = supplier.id;
    this.getGifts();
  }
}
